import React, { useEffect } from "react";
import "../App.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import BusinessLogin from "./BusinessLogin";
import InvestorLogin from "../InvestorFlow/InvestorLogin";
import { useState } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import { TURNSTILE_SITEKEY } from "../utilities";


const LoginPage = () => {
  const [canSubmit, setCanSubmit] = useState(false);
  const [activeTab, setActiveTab] = useState("business_login");

  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth < 920) {
  //       alert("Access restricted to desktop devices only. Please use a desktop device to continue.");
  //     }
  //   };
  //   handleResize();
  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);


  const renderContent = () => {
    if (activeTab === "business_login") {
      console.log("business_login");
      return (
        <div>
          <h4 className="mb-3 d-flex justify-content-center">

            <img
              className="img-fluid login-logo"
              src="./images/BenneFin-Logo-New.png"
              alt="BenneFin Logo"
            />
          </h4>

          <BusinessLogin />
        </div>
      );
    } else if (activeTab === "investor_login") {
      console.log("investor_login");

      return (
        <div>
          <h4 className="mb-3 d-flex justify-content-center">


            <img
              className="img-fluid login-logo"
              src="./images/BenneFin-Logo-New.png"
              alt="BenneFin Logo"
            />

          </h4>

          <InvestorLogin />
        </div>
      );
    }
  };


  return (
    <div >
      {!canSubmit ? <div className='position-absolute top-50 start-50 translate-middle'>
        <div className="d-flex flex-column justify-content-center align-items-cneter">
          <h5>Verifying you are human. This may take a few seconds.</h5>
          <Turnstile
            className="mt-3"
            options={{
              action: 'submit-form',
              theme: 'light'
            }}
            id='turnstile-1'
            siteKey={TURNSTILE_SITEKEY}
            onSuccess={() => setTimeout(() => setCanSubmit(true), 2000)}
          />
        </div>
      </div> :
        <div className="row m-0 flex-row-reverse">
          <div className="col-lg-6 p-4 p-lg-0 py-5 py-lg-0 d-flex justify-content-center align-items-center">
            <div className=" justify-content-center login_input_space">

              {/* <div className="">
              <Tabs
                defaultActiveKey="business_login"
                id="uncontrolled-tab-example"
                className="mb-1 mb-lg-5 d-flex justify-content-between ps-2 pe-2"
              >
                <Tab className="" eventKey="business_login" title="Business Login">
                <h4 className="mb-3 d-flex justify-content-center ">
              <img className="img-fluid " src="./images/BenneFin-Logo-New.png" alt="true" style={{ width:"400px",height:"75px"}}/>
            </h4>
                  <BusinessLogin canSubmit={canSubmit}/>
                </Tab>
                <Tab eventKey="investor_login" title="Investor Login" className="Investor_Tab_title">
                <h4 className="mb-3 d-flex justify-content-center">
              <img className="img-fluid" src="./images/BenneFin-Logo-New.png" alt="true" style={{ width:"400px",height:"75px"}}/>
            </h4>
                  <InvestorLogin canSubmit={canSubmit}/>
                </Tab>
              </Tabs>
            </div> */}

              <div className="container-fluid px-0">
                <div className="mb-1 mb-lg-5 d-flex flex-wrap justify-content-between gap-2 ps-2 pe-2">
                  <button
                    className={`btn px-3 ${activeTab === "business_login" ? "btn-primary" : "btn-outline-primary  login_btn_outline"
                      } me-2`}
                    onClick={() => setActiveTab("business_login")}
                  >
                    <h5>Business Login</h5>
                    {/* Business Login */}
                  </button>
                  <button
                    className={`btn px-3 ${activeTab === "investor_login" ? "btn-primary" : "btn-outline-primary login_btn_outline"
                      }`}
                    onClick={() => setActiveTab("investor_login")}
                  >
                    <h5>Investor Login</h5>
                    {/* Investor Login */}
                  </button>
                </div>
                {renderContent()}
              </div>
            </div>
          </div>



          <div className="col-lg-6 login_main p-0 position-relative d-none d-lg-block">
            <img
              className=" login_main_img position-relative"
              src="./images/login_background.svg"
              alt="true"
            />
            <img className="position-absolute login_txt" src="./images/login_rotated_text.svg" alt="true" />
          </div>
        </div>}
    </div>
  );
};

export default LoginPage;
